var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAppleForYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-apple_for_you") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "--\\u21B3-Icons---\\u2660\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/apple_for_you"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple_for_you"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "cell",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.230909,6 C29.3191682,6 25.885045,8.04463568 24,11.096277 C22.113139,8.04463568 18.6808318,6 14.767275,6 C10.1599927,6 6.07209662,8.88410728 4.64106057,13.0598478 C4.2142922,14.0254203 4,15.1819455 4,16.5006005 C4,28.9647718 22.3546718,41.2271818 23.1373831,41.7423939 C23.3988922,41.9135308 23.6985381,42 24,42 C24.3014619,42 24.6011078,41.9135308 24.8626169,41.7423939 C25.6435122,41.2271818 44,28.9647718 44,16.5006005 C44,15.1783426 43.7838918,14.020016 43.4043403,13.178743 C41.9279034,8.88410728 37.8400073,6 33.230909,6",
    id: "love",
    fill: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-dummy-icon",
    stroke: "#FF6666",
    strokeDasharray: "2,3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L46,46",
    id: "Line",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L46,46",
    id: "Line",
    strokeWidth: 2,
    transform: "translate(23.000000, 23.000000) rotate(-270.000000) translate(-23.000000, -23.000000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppleForYou);
export default __webpack_public_path__ + "static/media/icon-apple_for_you.699d7ef2f5bf5fda0f5450a96747fffc.svg";
export { ForwardRef as ReactComponent };